var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgVisibilityOff = function SvgVisibilityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 21L2 3l1.06-1.06 18 18L20 21z",
    fill: "#222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.463 16.34A11.884 11.884 0 0023 11.5C21.27 7.11 17 4 12 4c-1.454 0-2.847.263-4.133.744l1.184 1.184A10.298 10.298 0 0112 5.5c4.15 0 7.729 2.455 9.37 6a10.387 10.387 0 01-2.973 3.774l1.066 1.066zM15.2 12.076a3.25 3.25 0 00-3.775-3.775l3.775 3.775zM9.967 8.965a3.25 3.25 0 104.568 4.568l-1.072-1.072a1.75 1.75 0 11-2.424-2.424L9.967 8.965zM7.523 6.521A10.38 10.38 0 002.631 11.5c1.64 3.545 5.22 6 9.369 6 1.868 0 3.621-.498 5.133-1.369l1.094 1.094A11.745 11.745 0 0112 19c-5 0-9.27-3.11-11-7.5a11.887 11.887 0 015.408-6.093L7.523 6.52z",
    fill: "#222"
  })));
};
export default SvgVisibilityOff;